"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _APTable = _interopRequireDefault(require("../common/APTable"));
var _APButton = _interopRequireDefault(require("../common/APButton"));
var _commonComponent = require("../../propTypes/commonComponent");
var _dateHelper = require("../../helpers/dateHelper");
var _numberFormatter = require("../../helpers/numberFormatter");
require("./TransferComponents.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('transfers');
var TransfersComponent = function TransfersComponent(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('transfer'),
    t = _useTranslation.t;
  var getAmountRow = function getAmountRow(_ref) {
    var Amount = _ref.Amount,
      product = _ref.product;
    return getMultilineCell((0, _numberFormatter.formatNumberToLocale)(Amount, product.DecimalPlaces), product.ProductFullName);
  };
  var getDateRow = function getDateRow(_ref2) {
    var CreatedTimestamp = _ref2.CreatedTimestamp;
    return getMultilineCell((0, _dateHelper.formatDate)(CreatedTimestamp), (0, _dateHelper.formatTime)(CreatedTimestamp));
  };
  var getMultilineCell = function getMultilineCell(primarytext, secondaryText) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: baseClasses('multiline-col')
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: baseClasses('primary-text')
    }, primarytext), /*#__PURE__*/_react["default"].createElement("div", {
      className: baseClasses('secondary-text')
    }, secondaryText));
  };

  // eslint-disable-next-line react/display-name -- inline cell renderer for react-table
  var getCell = function getCell(field) {
    return function (row) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('primary-text')
      }, row[field]);
    };
  };
  var getActionButtons = function getActionButtons(row) {
    if (row.Status === 'TransferCompleted' || row.Status === 'PayerRejected') {
      return null;
    }
    return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
      styleName: _commonComponent.styleNames.additive,
      onClick: function onClick() {
        return allowRequest(row);
      }
    }, t('Approve')), /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
      styleName: _commonComponent.styleNames.subtractive,
      onClick: function onClick() {
        return rejectRequest(row);
      }
    }, t('Reject')));
  };
  var getTransfersColumns = function getTransfersColumns() {
    return [{
      header: t('Action'),
      classModifier: 'transfers-action',
      cell: function cell(row) {
        var selectedFilter = props.selectedFilter;
        var isSent = selectedFilter === 'sentTransfers';
        var sent = "".concat(t('Sent'), " ").concat(row.product.ProductFullName);
        var received = "".concat(t('Received'), " ").concat(row.product.ProductFullName);
        var from = "".concat(t('From'), " ").concat(row.SenderUserName);
        var to = "".concat(t('To'), " ").concat(row.ReceiverUserName);
        return isSent ? getMultilineCell(sent, to) : getMultilineCell(received, from);
      }
    }, {
      header: t('Amount'),
      cell: getAmountRow,
      classModifier: 'amount'
    }, {
      header: t('Note'),
      cell: getCell('Notes')
    }];
  };
  var allowRequest = function allowRequest(req) {
    props.approveTransferRequest(req.RequestCode);
  };
  var rejectRequest = function rejectRequest(req) {
    props.rejectTransferRequest(req.RequestCode);
  };
  var getRequestsSentColumns = function getRequestsSentColumns() {
    return [{
      header: t('Recipient'),
      classModifier: 'recipient',
      cell: function cell(row) {
        return getMultilineCell("".concat(t('You requested to Receive'), " ").concat(row.product.ProductFullName), "".concat(t('To'), " ").concat(row.PayerUsername));
      }
    }, {
      header: t('Amount'),
      classModifier: 'amount',
      cell: getAmountRow
    }, {
      header: t('Time'),
      classModifier: 'time',
      cell: getDateRow
    }, {
      header: t('Note'),
      classModifier: 'note',
      cell: getCell('Notes')
    }, {
      header: t('Status'),
      classModifier: 'status',
      cell: getCell('Status')
    }];
  };
  var getRequestsReceivedColumns = function getRequestsReceivedColumns() {
    return [{
      header: t('Sent By'),
      classModifier: 'sent-by',
      cell: function cell(row) {
        return getMultilineCell("".concat(t('Request for you to send'), " ").concat(row.product.ProductFullName), "".concat(t('From'), " ").concat(row.RequestorUsername));
      }
    }, {
      header: t('Amount'),
      classModifier: 'amount',
      cell: getAmountRow
    }, {
      header: t('Time'),
      classModifier: 'time',
      cell: getDateRow
    }, {
      header: t('Note'),
      classModifier: 'note',
      cell: getCell('Notes')
    }, {
      header: t('Status'),
      classModifier: 'status',
      cell: getCell('Status')
    }, {
      header: t('Action'),
      cell: getActionButtons
    }];
  };
  var getColumns = function getColumns(selectedFilter) {
    var columnsMethods = {
      sentTransfers: getTransfersColumns,
      receivedTransfers: getTransfersColumns,
      sentRequests: getRequestsSentColumns,
      receivedRequests: getRequestsReceivedColumns
    };
    return columnsMethods[selectedFilter]();
  };
  var usePagination = props.usePagination,
    selectedFilter = props.selectedFilter;
  var columns = getColumns(selectedFilter);
  var items = props[selectedFilter];
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('wrapper')
  }, /*#__PURE__*/_react["default"].createElement(_APTable["default"], {
    componentName: 'TransfersComponent',
    columns: columns,
    pageSize: 6,
    minRow: 6,
    rows: items,
    baseClass: baseClasses,
    headerOutside: true,
    usePagination: usePagination,
    empty: t('No data is available')
  }));
};
var _default = exports["default"] = TransfersComponent;